// User
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const GET_ADVISORS = 'GET_ADVISORS'
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const GET_CLIENTS = 'GET_CLIENTS'
export const SET_TOKENS = 'SET_TOKENS'
export const SET_USER = 'SET_USER'
// Assets
export const PROFIL_PICTURE = 'PROFIL_PICTURE'



// WEBPACK FOOTER //
// ./src/store/modules/Users/types.js